import { gql } from '@apollo/client';

export const GET_LOGO = gql`
  query GetLogo {
    GetLogo
  }
`;
